import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M22 12C22 6.48 17.52 2 11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12ZM12.5 12.25V7H11V13L16.25 16.15L17 14.92L12.5 12.25Z"
    fillRule="evenodd"
  />,
  'TimeMFill',
)
